import { FC } from "react";
import { useTranslation } from "react-i18next";

import { ThemedCheckbox } from "@/App/components";
import { Stack } from "capitalrx-components-2.0/lib/layout";
import { Subheading } from "capitalrx-components-2.0/lib/typography";

const TRANSLATION_PATH = "DIRECT_MEMBER_REIMBURSEMENT.directMemberReimbursementAcknowledgeField";

interface DirectmembeReimbursementAcknowledgeFieldProps {
  readonly fieldName: string;
}

export const DirectMemberReimbursementAcknowledgeField: FC<DirectmembeReimbursementAcknowledgeFieldProps> = ({ fieldName }) => {
  const { t: translate } = useTranslation();

  return (
    <Stack spacing="medium">
      <Subheading>{translate(`${TRANSLATION_PATH}.acknowledge`)}</Subheading>
      <ThemedCheckbox.Field
        name={fieldName}
        label={translate(`${TRANSLATION_PATH}.acknowledgeContent`)}
        hideLabel
        required
      />
    </Stack>
  );
};
